<template>
    <div class="notification-sample">
        <div v-if="isThemeSfr" class="notification-header">
            <div class="icon" :style="{backgroundImage:'url('+sfrLogo+')'}"></div>
            <div class="app-label">SFR DATI</div>
        </div>
        <div v-else-if="isThemeCatsafe" class="notification-header">
            <div class="icon" :style="{backgroundImage:'url('+catsafeLogo+')'}"></div>
            <div class="app-label">CAT'SAFE</div>
        </div>
        <div v-else class="notification-header">
            <div class="icon" :style="{backgroundImage:'url('+appLogo+')'}"></div>
            <div class="app-label">Beepiz</div>
        </div>
        <div class="notification-content">
            <div class="title">
                {{ title }}
                <span class="placeholder" :class="{show:title == ''}">&nbsp;</span>
            </div>
            <div class="description pre-style"><!--
                -->{{ description }}<!--
                --><span class="placeholder" :class="{show:description == ''}">&nbsp;</span>
            </div>
        </div>
    </div>
</template>

<script>
    import Utils from '@/services/utils.js';

    const appLogo = require("@/assets/img/app_logo.png");
    const sfrLogo = require("@/assets/img/beepiz-sfr.png");
    const catsafeLogo = require("@/assets/img/logo-catsafe-square-light.png");

    export default {
        name: 'Notification',
        props: {
            title: {
                type: String,
                required:true
            },
            description: {
                type: String,
                required: false,
                default: ""
            }
        },
        data() {
            return {
                appLogo,
                sfrLogo,
                catsafeLogo,
            }
        },
        computed: {
            isThemeSfr(){
                return Utils.isThemeSfr()
            },
            isThemeCatsafe(){
                return Utils.isThemeCatsafe()
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>
